import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../../utils/app-settings';
import {
  ICreateMotivoNoEntrega,
  IGetMotivosPaginated,
  IMotivoNoEntrega,
  IUpdateMotivoNoEntrega,
} from '../../interfaces/motivo-no-entrega.interface';

interface IApiResponse<T> {
  statusCode: number;
  message: string;
  data: T;
}

@Injectable({
  providedIn: 'root',
})
export class MotivoNoEntregaService {
  constructor(
    private http: HttpClient,
    private appSettings: AppSettings,
  ) {}

  getMotivos(page: number = 1, pageSize: number = 10): Observable<IGetMotivosPaginated> {
    const url = `${this.appSettings.motivosNoEntrega.urls.getMotivosNoEntrega}?page=${page}&pageSize=${pageSize}`;
    return this.http.get<IGetMotivosPaginated>(url);
  }

  createMotivo(
    dto: ICreateMotivoNoEntrega,
  ): Observable<IApiResponse<IMotivoNoEntrega>> {
    return this.http.post<IApiResponse<IMotivoNoEntrega>>(
      this.appSettings.motivosNoEntrega.urls.createMotivoNoEntrega,
      dto,
    );
  }

  updateMotivo(
    id: number,
    dto: IUpdateMotivoNoEntrega,
  ): Observable<IApiResponse<IMotivoNoEntrega>> {
    return this.http.patch<IApiResponse<IMotivoNoEntrega>>(
      `${this.appSettings.motivosNoEntrega.urls.updateMotivoNoEntrega}/${id}`,
      dto,
    );
  }

  deleteMotivo(id: number): Observable<IApiResponse<null>> {
    return this.http.delete<IApiResponse<null>>(
      `${this.appSettings.motivosNoEntrega.urls.deleteMotivoNoEntrega}/${id}`,
    );
  }
}
